var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsured({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: #b49f7d;\n      }\n\n      .st1 {\n        stroke: #b49f7d;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.4,16.5s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0l-13.5-13.5s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0H31.5c-2,0-3.7,1.7-3.7,3.7v5.7h-14.5c-2,0-3.7,1.7-3.7,3.7v79c0,2,1.7,3.7,3.7,3.7h55.1c2,0,3.7-1.7,3.7-3.7v-5.7h14.5c2,0,3.7-1.7,3.7-3.7V16.5s0,0,0,0ZM76.8,5l10.6,10.6h-8.6c-1.1,0-2-.9-2-2V5ZM86.6,86.8H31.5c-1.1,0-2-.9-2-2V5.8c0-1.1.9-2,2-2h43.6v9.8c0,2,1.7,3.7,3.7,3.7h9.8v67.4c0,1.1-.9,2-2,2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 39.7,
    y: 24.2,
    width: 29.4,
    height: 4.2,
    rx: 2.1,
    ry: 2.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 39.7,
    y: 33.5,
    width: 38.8,
    height: 4.2,
    rx: 2.1,
    ry: 2.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 39.7,
    y: 42.8,
    width: 38.8,
    height: 4.2,
    rx: 2.1,
    ry: 2.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 39.7,
    y: 52.1,
    width: 38.8,
    height: 4.2,
    rx: 2.1,
    ry: 2.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 39.7,
    y: 62.3,
    width: 38.8,
    height: 4.2,
    rx: 2.1,
    ry: 2.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 39.7,
    y: 71.6,
    width: 19.6,
    height: 4.2,
    rx: 2.1,
    ry: 2.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsured);
export default __webpack_public_path__ + "static/media/insured.d26418e15d9cfff258d9132c3a29a03d.svg";
export { ForwardRef as ReactComponent };